import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Image } from "react-bootstrap";
import Header from "../Helper/Header";
import NewFooter from "../Helper/NewFooter";
import { BASE_URL } from "../../constants";

const NewsDetail = () => {
  const { id } = useParams();
  const [newsItem, setNewsItem] = useState(null);

  const news = [
    {
      id: "Dsider x CORYS Partnership",
      image: "news/dsider_main_news.png",
      title: "Dsider x CORYS Partnership",
      text: "We are thrilled to announce a strategic partnership between CORYS and Dsider, marking a transformative step in delivering next-generation solutions in navigating a path to net zero from FEL and FEED stages through commissioning and operations! \n This MoU signifies a shared commitment to combining cutting-edge expertise in real-time dynamic process modeling with state-of-the-art techno economic decision intelligence, ensuring our clients achieve unparalleled efficiency, safety, and returns for new energy projects. Together, Dsider and CORYS will empower industries to make smarter, faster, and more informed decisions with scalable, integrated solutions. \n \n Stay tuned for updates as we bring this partnership to life. \n The Future of Intelligent Operations Begins Today!",
    },
    {
      id: "analytics-shaping-the-future-of-energy-transition",
      image: "news/recent_news_1.png",
      title: "Analytics Shaping the Future of Energy Transition",
      text: "Imagine one platform that provides operations forecasting, financial – risk – carbon abatement – scenario analysis, and data integration all in one location. This integrated platform can help accelerate the energy transition and do it with precision. \n \n More about Sujatha \n Sujatha Kumar, an entrepreneur and senior technology executive, is the Founder and CEO of Dsider. With a background in senior management roles at multiple technology companies in the energy sector, she notably led one of them to a successful sale to Honeywell. With considerable experience in both operations and digital domains, she possesses a passion for introducing innovative products and concepts to organizations Sujatha and her team possess extensive experience in energy and industrial markets, focusing on mid to large enterprises. \n In addition to her responsibilities at Dsider, Sujatha serves as an advisor at Knightsgate Ventures and collaborates with various startups. She also contributes her expertise as an advisor and board member to both public companies and startups. \n \n About Dsider: \n Dsider enterprise planning solution empowers engineers and financial planners navigate energy transition initiatives – through operational analysis, capital allocation to return on investment. Dsider streamlines the analysis for energy planning, emission calibration, resource efficiency, and financial computations in one place. \n Collaboration and forecasting features facilitate seamless planning and execution of sustainability initiatives.   Dsider, a SaaS offering focused on the energy and industrial markets reduces risks and increases decision confidence while accelerating energy transition with ease and precision.",

    },
    {
      id: "empowering-sustainability-through-digital-innovation",
      image: "news/recent_news_2.png",
      title: "Empowering Sustainability through Digital Innovation",
      text: "We are pleased to share that Sujatha Kumar, Founder and CEO, Dsider.",

    },
    {
      id: "musings-on-netzero-planning-1",
      image: "news/recent_news_3.png",
      title: "Musings on Netzero Planning - #1",
      text: "With mixed results on climate action, A new year always offers hope for.",
    },
  ];

  useEffect(() => {
    const item = news.find((item) => item.id === id);
    setNewsItem(item);
  }, [id]);

  if (!newsItem) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div>Loading news article...</div>
      </div>
    );
  }

  return (
    <>
      <Header />
      <Container className="news-page">
        <Row className="text-center my-5">
          <Col>
            <div className="news-heading">Dsider Recent News</div>
          </Col>
        </Row>
        <Row className="text-center">
          <Col>
            <Image
              src={`${BASE_URL}${newsItem.image}`}
              alt="Dsider News"
              fluid
              className="news-image"
              style={{ width: "850px", height: "501px", border: "none" }}
            />
          </Col>
        </Row>
        <Row className="my-4">
          <Col>
            <div className="news-subheading">{newsItem.title}</div>
            <p className="news-text" style={{ whiteSpace: "pre-line" }}>
              {newsItem.text}
            </p>
          </Col>
        </Row>
      </Container>
      <NewFooter />
    </>
  );
};

export default NewsDetail;